export var IdAnimDog;
(function (IdAnimDog) {
    IdAnimDog["Bowl"] = "bowl";
    IdAnimDog["Idle"] = "idle";
    IdAnimDog["IdleHappy"] = "idle_happy";
    IdAnimDog["Jumping"] = "jumping";
    IdAnimDog["Playful"] = "playful";
    IdAnimDog["Scratch"] = "scratch";
    IdAnimDog["Sit"] = "sit";
    IdAnimDog["Sniff"] = "sniff";
})(IdAnimDog || (IdAnimDog = {}));
export var ListDogAnimation = {
    Idle: [IdAnimDog.Idle, IdAnimDog.IdleHappy],
    Interactive: [IdAnimDog.Bowl, IdAnimDog.Playful, IdAnimDog.Scratch, IdAnimDog.Sit],
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/IdAnimDog.ts
// module id = 577
// module chunks = 3